import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { selectUser } from "../../APIServices/userReducer";
import { useOutsideAlerter } from "../../SharedFiles/DropdownCloser/dropdownCloser";
import './Header.css';
import { decryptUserInfo } from "../decryption/Decryption";
import { logout } from "../../APIServices/Login/loginSlice";
import i18n from "../../../i18n";

const Header = ({ itemSearchTerm, ItemInputChange }) => {
    const userData = sessionStorage.getItem('user');
    const dispatch = useDispatch();
    // const user = useSelector(selectUser);
    
    const parsedUserData = userData ? JSON.parse(userData) : null;
    const decryptedUserInfo = parsedUserData && decryptUserInfo(parsedUserData);
    const UserName = decryptedUserInfo && decryptedUserInfo[0].USERNAME;
    const navigate = useNavigate();
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const wrapperRef = useRef(null);

    // Close dropdown when clicking outside
    useOutsideAlerter(wrapperRef, () => setDropdownVisible(false));


    const handleIconClick = () => {
        setDropdownVisible(prevState => !prevState);
    };

    
    // Get the first letter of the username
    const firstLetter = UserName ? UserName.charAt(0).toUpperCase() : "";

    const handleLanguageChange = (lang) => {
        i18n.changeLanguage(lang);  
        setDropdownVisible(false);
    };

    const handleLogout = async () => {
        i18n.changeLanguage('en');
        // sessionStorage.removeItem('user'); 
        dispatch(logout());
        navigate("/");
    };


    return (
        <div className="header d-flex justify-content-between align-items-center sticky-top bg-light shadow-sm p-3">
            <div className="headerLogo">
                <img src="/melwa-logo.png" alt="Melwa Logo" width="100" height="27" className="img-fluid" />
            </div>

           

            {/* Dropdown Menu for User Info */}
            <div className="dropdown" ref={wrapperRef}>
                <div className="userheader d-flex align-items-center" onClick={handleIconClick}>
                <div className="avatar-circle d-flex justify-content-center align-items-center">
                 {firstLetter}
                </div>
                </div>
               

                {/* Dropdown Menu */}
                {dropdownVisible && (
                    <div 
                        className="dropdown-menu-custom shadow-sm p-3 mt-2 bg-white border" 
                        aria-labelledby="dropdownMenuButton">
                        {/* Username centered */}
                        <div className="dropdown-item text-center">
                            <strong>{UserName}</strong>
                        </div>

                 {/* Language dropdown */}
                <div className="language-selector">
                <select onChange={(e) => handleLanguageChange(e.target.value)} className="form-select" style={{ width: "100%" }} value={i18n.language}>
                    <option value="en">English</option>
                    <option value="ta">தமிழ்</option>
                    <option value="si">සිංහල</option>
                </select>
            </div>

                        {/* Bootstrap Red Button with Hover Effect and Border Radius */}
                        <button
                            className="dropdown-item button sm mt-2 text-center rounded"
                            onClick={handleLogout}
                        >
                            Logout
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Header;
